import { render, staticRenderFns } from "./info-general.vue?vue&type=template&id=44734a2a&scoped=true"
import script from "./info-general.vue?vue&type=script&lang=js"
export * from "./info-general.vue?vue&type=script&lang=js"
import style0 from "./info-general.vue?vue&type=style&index=0&id=44734a2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44734a2a",
  null
  
)

export default component.exports